import { authApiCall } from '../../auth/saga';

export const getMembershipInfo = () =>
  authApiCall({
    url: '/subscription/current-plan-details/',
    method: 'get',
  });
